import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import {
    DEPOSITOR_COMPANY,
    DEPOSITOR_PERSON,
    isCompany,
} from '../../utils/depositor';
import { WebsocketsListener } from '../../utils/ws';

interface DepositorField {
    key: string;
    label: string;
    // Campul are butonul de preluare a datelor firmei de la ANAF.
    lookup?: boolean;
}

const PERSON_FIELDS: DepositorField[] = [
    { key: 'firstName', label: 'Prenume' },
    { key: 'lastName', label: 'Nume' },
    { key: 'series', label: 'Serie Buletin' },
    { key: 'number', label: 'Numar Buletin' },
    { key: 'pin', label: 'CNP' },
    { key: 'address', label: 'Adresa Domiciliu' },
];

// La firma, prenumele si numele sunt ale reprezentantului.
const COMPANY_FIELDS: DepositorField[] = [
    { key: 'companyName', label: 'Denumire firma' },
    { key: 'cui', label: 'CUI', lookup: true },
    { key: 'registrationNumber', label: 'Nr. Reg. Com.' },
    { key: 'address', label: 'Sediu' },
    { key: 'firstName', label: 'Reprezentant - Prenume' },
    { key: 'lastName', label: 'Reprezentant - Nume' },
];

const COMMON_FIELDS: DepositorField[] = [
    { key: 'phone', label: 'Telefon' },
    { key: 'email', label: 'Email' },
    { key: 'bankAccount', label: 'Cont Bancar' },
];

// Datele unui deponent, persoana fizica sau juridica. Se foloseste cu v-model.
@Component
export default class DepositorForm extends Vue {
    @Prop({ type: Object, required: true }) readonly value!: any;

    readonly types = [
        { value: DEPOSITOR_PERSON, text: 'Persoana fizica' },
        { value: DEPOSITOR_COMPANY, text: 'Persoana juridica' },
    ];

    anaf = { requestId: '', loading: false, error: '', warning: '' };

    // Creat in `mounted`, nu in constructor: callback-ul trebuie legat de
    // instanta reactiva (vezi views/depositors/list).
    private listener?: WebsocketsListener;

    get type(): string {
        return isCompany(this.value) ? DEPOSITOR_COMPANY : DEPOSITOR_PERSON;
    }

    get fields(): DepositorField[] {
        return (isCompany(this.value) ? COMPANY_FIELDS : PERSON_FIELDS).concat(
            COMMON_FIELDS,
        );
    }

    // Obiectul e modificat pe loc: o copie pornita din prop-ul inca
    // neactualizat ar pierde campurile completate in acelasi tick (autofill).
    update(key: string, value: string) {
        this.$set(this.value, key, value);
        this.$emit('input', this.value);
    }

    lookupCompany() {
        this.anaf.requestId = `${Date.now()}-${Math.random()}`;
        this.anaf.loading = true;
        this.anaf.error = '';
        this.anaf.warning = '';

        (this.listener as WebsocketsListener).sendGet(
            'admin.depositors.company',
            { cui: this.value.cui, requestId: this.anaf.requestId },
        );
    }

    /** Completeaza denumirea, Reg. Com. si sediul; telefonul doar daca lipseste. */
    onCompanyFound(success: boolean, data: any) {
        if (!data || data.requestId !== this.anaf.requestId) return;

        this.anaf.requestId = '';
        this.anaf.loading = false;

        if (!success) {
            this.anaf.error = data.message;
            return;
        }

        const company = data.company;
        this.update('companyName', company.companyName);
        this.update('registrationNumber', company.registrationNumber);
        this.update('address', company.address);
        if (!this.value.phone && company.phone) {
            this.update('phone', company.phone);
        }

        if (company.inactive) {
            this.anaf.warning =
                'Atentie: firma figureaza ca inactiva sau radiata la ANAF.';
        }
    }

    mounted() {
        this.listener = new WebsocketsListener();
        this.listener.onGet('admin.depositors.company', this.onCompanyFound);
    }

    beforeDestroy() {
        if (this.listener) {
            this.listener.destroy();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/depositor-form/index.ts